module.exports = __webpack_public_path__ + "static/media/cryptogirl.915da4f5.svg";